import { Divider } from '@betrybe/ada-react';
import { styled } from '@/configs/stitches.config';
import List from '../../List';

const Root = styled('div', {
  alignSelf: 'center',
  padding: '$spacingMd',
  display: 'flex',
  flexDirection: 'column',
  border: '$borderColorMedium 1px solid',
  borderRadius: '$borderRadiusLg',
  boxShadow: '$shadowBase',
  width: '100%',

  '@lg': {
    maxWidth: '16.5rem',
  },
});

const CardHeader = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

const Badge = styled('div', {
  textTransform: 'uppercase',
  backgroundColor: '#3F277A',
  color: '#fff',
  paddingBlock: '$spacingXs',
  paddingInline: '$spacingSm',
  borderRadius: '$borderRadiusXl',
  font: '$captionBold',
  height: '1rem',
});

const Logo = styled('img', {
  width: '3rem',
});

const Title = styled('h3', {
  font: '$headingMdBold',
  textWrap: 'balance',
});

const Description = styled('p', {
  font: '$bodyRegular',
  marginBlock: '$spacingMd',
});

const ListIcon = styled('img', {
  width: '14px',
  height: '14px',
  marginTop: '4px',
});

const AdaDivider = styled(Divider, {
  margin: 0,
});

const PaymentMethodCard: React.FC = () => {
  return (
    <Root>
      <CardHeader>
        <Badge>Financiamento</Badge>
        <Logo src="/assets/images/trybe-logo.svg" alt="Logo da Trybe" />
      </CardHeader>
      <Title>Pagamento Facilitado com 15 meses de carência</Title>
      <Description>
        Para quem consegue pagar uma pequena entrada e quer financiar o restante
        em parcelas fixas e mensais, após um período de carência.
      </Description>
      <AdaDivider position="horizontal" />
      <List.Root
        listStyleType="none"
        css={{ paddingLeft: 0, margin: 0, marginTop: '$spacingMd' }}
      >
        <List.Item
          icon={<ListIcon src="/assets/images/purple_check_circle.svg" />}
        >
          Entrada + Parcelas após 15 meses
        </List.Item>
        <List.Item
          icon={<ListIcon src="/assets/images/purple_check_circle.svg" />}
        >
          Sem taxa de matrícula
        </List.Item>
        <List.Item
          icon={<ListIcon src="/assets/images/purple_check_circle.svg" />}
        >
          Parcelas mensais fixas
        </List.Item>
        <List.Item
          icon={<ListIcon src="/assets/images/purple_check_circle.svg" />}
        >
          Experimente por 30 dias sem custo
        </List.Item>
      </List.Root>
    </Root>
  );
};

export default PaymentMethodCard;
